import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { FaCircleXmark } from "react-icons/fa6";

export const SuccessCheckMark = () => {
  return <FaCheckCircle size={19} style={{ color: "#00cc88" }} />;
};

export const ErrorCheckMark = () => {
  return <FaCircleXmark size={19} style={{ color: "#ff3366" }} />;
};
